import {Em, Text, Flex, Section, Button} from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import ProfileDropdown from "../components/ProfileDropdown/ProfileDropdown";

const Home = () => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  const handleClickRegister = () => {
  navigate("/register");
}
  const handleClickSearch = () => {
    navigate("/search");
  }
  
  return (
  user?._id ? (
    <Section minHeight="100vh">
    <h1> test </h1>
    <ProfileDropdown />
    </Section>
  ) : (
  <Section minHeight="100vh">
      <Flex align = "center" justify = "center" display = "flex" minHeight = "40vh">
        <Text size = "9">
            <Em>Welcome to CineMinds!</Em>
        </Text>
      </Flex> 
      <Flex align = "center" justify = "center" display = "flex" maxHeight = "30vh" gap ="9">
            <Button size = "4" variant = "soft" onClick = {handleClickRegister}> 
              Get Started
            </Button>
            <Button size = "4" variant = "outline" onClick ={handleClickSearch}> 
              Browse Movies
            </Button>
      </Flex> 
      </Section>
    )
)}

export default Home;
